var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card", "tab-position": "top" },
          model: {
            value: _vm.tabname,
            callback: function ($$v) {
              _vm.tabname = $$v
            },
            expression: "tabname",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "GHTK", name: "GHTK" } },
            [_c("pickup-address-table", { attrs: { type: "GHTK" } })],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "GHN", name: "GHN" } },
            [_c("pickup-address-table", { attrs: { type: "GHN" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }